exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-fa6f38ea] .md-table-head-label {\n  color: #4caf50 !important;\n}\n[data-v-fa6f38ea] .md-table-head {\n  cursor: default;\n}\n.table-hover[data-v-fa6f38ea] {\n  cursor: pointer;\n}\n.label-total[data-v-fa6f38ea] {\n  float: right;\n  font-size: 14px;\n  font-weight: 500;\n}\n.label-total span[data-v-fa6f38ea] {\n    display: block;\n}\n.rating[data-v-fa6f38ea] {\n  width: 140px;\n  min-width: 140px;\n}\n.default-star-rating[data-v-fa6f38ea] {\n  color: rgba(0, 0, 0, 0.54);\n}\n.orange-star[data-v-fa6f38ea] {\n  color: orange !important;\n}\n", ""]);

// exports
